import { LoginDataProps } from "@/data/types/login";
import { PAGES } from "@/data/types/pages";
import { LocaleDataFetcher } from "@/services/LocaleDataFetcher/LocaleDataFetcher";
import { AuthModalDataProps, HandleAuthModalForExpiredUsersProps } from "./types";
import { RegisterDataProps } from "@/data/types/register";
import { RecoverPasswordDataProps } from "@/data/types/recover-password";
import { paths } from "./paths";

export const getAuthModalData = async (
  lang: string
): Promise<AuthModalDataProps> => {
  const loginDataFetcher = new LocaleDataFetcher<LoginDataProps>({
    page: PAGES.LOGIN,
    language: lang,
  });
  const registerDataFetcher = new LocaleDataFetcher<RegisterDataProps>({
    page: PAGES.REGISTER,
    language: lang,
  });
  const recoverPasswordDataFetcher =
    new LocaleDataFetcher<RecoverPasswordDataProps>({
      page: PAGES.RECOVER_PASSWORD,
      language: lang,
    });

  const { data: loginData } = await loginDataFetcher.getDataWithTranslations();
  const { data: registerData } =
    await registerDataFetcher.getDataWithTranslations();
  const { data: recoverPasswordData } =
    await recoverPasswordDataFetcher.getDataWithTranslations();

  return {
    loginData,
    registerData,
    recoverPasswordData,
  };
};

export const handleAuthModalForExpiredUsers = ({ formType, modalContext, router, callback, logout }: HandleAuthModalForExpiredUsersProps) => {
  modalContext?.handleModal({});

  if (formType === "login") {
    callback();
  } else {
    logout();
    router.replace(paths.home());
  }
}